import React, { createContext, useState } from 'react';

export const SymbolInfoContext = createContext();

const SymbolContext = ({children}) => {
const[particularSymbol,setParticularSymbol]= useState("EURUSD");

const TakeSymbolFuntion=(symbolInfo)=>{
    setParticularSymbol(symbolInfo);
}
    return (
        <>
            <SymbolInfoContext.Provider value={{particularSymbol,TakeSymbolFuntion}}>
                {children}
            </SymbolInfoContext.Provider>
        </>
    )
}

export default SymbolContext
